<section class="panel">
    @if (state === 'loading') {
    <div class="center"><mat-spinner diameter="32"></mat-spinner></div>
    } @else if (state === 'error' || !info) {
    <div class="center">
        <p>Não foi possível carregar os dados do webhook.</p>
        <button mat-stroked-button (click)="load()">Tentar novamente</button>
    </div>
    } @else {
    <div class="grid">
        <div class="card">
            <h3>Endereço para o SRG-SCL</h3>
            <div class="url">
                <code>{{ baseUrl }}{{ '{entidade}' }}</code>
                <button mat-stroked-button (click)="copy(baseUrl)">Copiar base</button>
            </div>
            <p class="muted">
                Autenticação: cabeçalho <code>{{ info.secretHeader }}</code> (ou <code>Authorization: Bearer</code>) com o segredo;
                associação opcional em <code>{{ info.associationHeader }}</code>.
                {{ info.requireSignature ? 'Só aceita assinatura HMAC.' : 'Assinatura HMAC é opcional.' }}
            </p>
            <p [attr.data-ok]="info.configured">
                {{ info.configured ? 'Segredo configurado no servidor.' : 'Segredo NÃO configurado: o endpoint responde 503.' }}
            </p>
            <p class="muted">
                Último recebido:
                {{ info.lastReceivedAt ? (info.lastReceivedAt | date: 'dd/MM/yyyy HH:mm:ss') : 'nunca' }}
            </p>
            <button mat-flat-button color="primary" (click)="test()" [disabled]="testing">
                {{ testing ? 'Testando…' : 'Enviar teste' }}
            </button>
            <p class="muted">O teste grava e lê um evento marcado como teste na caixa de entrada; não chama o SRG-SCL.</p>
        </div>
        <div class="card">
            <h3>Entidades (últimos 7 dias)</h3>
            <ul class="ents">
                @for (e of entities; track e.entity) {
                <li>
                    <b>{{ e.entity }}</b>
                    <span class="tag" [attr.data-ok]="e.supported">{{ e.supported ? 'processada' : 'sem processamento' }}</span>
                    <span class="muted">{{ e.total }} recebido(s)</span>
                    @if (e.failed) {
                    <span class="err">{{ e.failed }} com falha</span>
                    } @if (e.last) {
                    <span class="muted">{{ e.last | date: 'dd/MM HH:mm' }}</span>
                    }
                </li>
                }
            </ul>
        </div>
    </div>
    }
</section>
